var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-card",
        [
          _c(
            "v-overlay",
            { attrs: { value: _vm.loader, absolute: true } },
            [
              _c(
                "v-row",
                { attrs: { justify: "center" } },
                [
                  _c("v-progress-circular", {
                    attrs: { indeterminate: "", size: "64" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-title",
            [
              _c("v-row", { attrs: { justify: "center" } }, [
                _c("h1", { staticClass: "text-xs-center primary--text" }, [
                  _vm._v(_vm._s(_vm.$t("setupUpdate"))),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                [
                  _c("v-col", [
                    _c("h1", { staticClass: "text-xs-center primary--text" }, [
                      _vm._v(" " + _vm._s(_vm.$t("changelog")) + " "),
                    ]),
                  ]),
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    [
                      _c(
                        "v-col",
                        { staticClass: "pt-0" },
                        _vm._l(_vm.changelogs, function (changelog) {
                          return _c("div", { key: changelog.version }, [
                            _c("p", { staticClass: "black--text" }, [
                              _c("b", [_vm._v("Version:")]),
                              _vm._v(" " + _vm._s(changelog.version) + " "),
                              _c("br"),
                              _c("b", [_vm._v("Beschreibung:")]),
                              _vm._v(" " + _vm._s(changelog.description) + " "),
                            ]),
                          ])
                        }),
                        0
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { attrs: { justify: "center" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "4" } },
                    [
                      _c(
                        "v-card",
                        { attrs: { outlined: "" } },
                        [
                          _c("v-card-title", [
                            _c(
                              "h1",
                              { staticClass: "text-xs-center primary--text" },
                              [_vm._v(_vm._s(_vm.$t("tables")))]
                            ),
                          ]),
                          _c(
                            "v-card-text",
                            _vm._l(_vm.tables, function (item) {
                              return _c(
                                "v-row",
                                { key: item.text },
                                [
                                  _c(
                                    "v-col",
                                    { staticClass: "pa-1" },
                                    [
                                      _c(
                                        "v-progress-linear",
                                        {
                                          attrs: {
                                            value: item.finishedInPercent,
                                            height: "25",
                                            color: "green",
                                            reactive: "",
                                          },
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(_vm._s(item.text)),
                                          ]),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                          _c(
                            "v-card-actions",
                            [
                              _c(
                                "v-col",
                                [
                                  _c(
                                    "v-row",
                                    { attrs: { justify: "end" } },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass:
                                            "textColor--text font-weight-medium buttonHoverOpacity",
                                          attrs: {
                                            color: "primary",
                                            disabled:
                                              _vm.tables.length == 0 ||
                                              _vm.disableTablesButton,
                                          },
                                          on: { click: _vm.createTables },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("execute")))]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "4" } },
                    [
                      _c(
                        "v-card",
                        { attrs: { outlined: "" } },
                        [
                          _c("v-overlay", {
                            attrs: {
                              value: _vm.loaderOverlayFields,
                              absolute: true,
                            },
                          }),
                          _c("v-card-title", [
                            _c(
                              "h1",
                              { staticClass: "text-xs-center primary--text" },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("tableFields")) + " "
                                ),
                              ]
                            ),
                          ]),
                          _c(
                            "v-card-text",
                            _vm._l(_vm.fields, function (item) {
                              return _c(
                                "v-row",
                                { key: item.text },
                                [
                                  _c(
                                    "v-col",
                                    { staticClass: "pa-1" },
                                    [
                                      _c(
                                        "v-progress-linear",
                                        {
                                          attrs: {
                                            value: item.table.finishedInPercent,
                                            height: "25",
                                            color: "green",
                                            reactive: "",
                                          },
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(item.table.TableName) +
                                                "(" +
                                                _vm._s(item.fields.length) +
                                                ")"
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                          _c(
                            "v-card-actions",
                            [
                              _c(
                                "v-col",
                                [
                                  _c(
                                    "v-row",
                                    { attrs: { justify: "end" } },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass:
                                            "textColor--text font-weight-medium buttonHoverOpacity",
                                          attrs: {
                                            color: "primary",
                                            disabled:
                                              _vm.fields.length == 0 ||
                                              _vm.disableFieldsButton,
                                          },
                                          on: { click: _vm.createFields },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("execute")))]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "4" } },
                    [
                      _c(
                        "v-card",
                        { attrs: { outlined: "" } },
                        [
                          _c("v-overlay", {
                            attrs: {
                              value: _vm.loaderOverlayDatas,
                              absolute: true,
                            },
                          }),
                          _c("v-card-title", [
                            _c(
                              "h1",
                              { staticClass: "text-xs-center primary--text" },
                              [_vm._v(" " + _vm._s(_vm.$t("tableData")) + " ")]
                            ),
                          ]),
                          _c(
                            "v-card-text",
                            _vm._l(_vm.data, function (item) {
                              return _c(
                                "v-row",
                                { key: item.tableName },
                                [
                                  _c(
                                    "v-col",
                                    { staticClass: "pa-1" },
                                    [
                                      _c(
                                        "v-progress-linear",
                                        {
                                          attrs: {
                                            value: item.finishedInPercent,
                                            height: "25",
                                            color: "green",
                                            reactive: "",
                                          },
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(item.tableName) +
                                                "(" +
                                                _vm._s(item.dataValues.length) +
                                                ")"
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                          _c(
                            "v-card-actions",
                            [
                              _c(
                                "v-col",
                                [
                                  _c(
                                    "v-row",
                                    { attrs: { justify: "end" } },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass:
                                            "textColor--text font-weight-medium buttonHoverOpacity",
                                          attrs: {
                                            color: "primary",
                                            disabled:
                                              _vm.data.length == 0 ||
                                              _vm.disableDataButton,
                                          },
                                          on: { click: _vm.createData },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("execute")))]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }